

let defaultState = {

    worldView: "WORLD_VIEW", // WORLD_VIEW, WORLD_INPUT, WORLD_SELECT (image selection), WORLD_PLACE
    searchType: "IMAGE_SEARCH" // IMAGE_SEARCH, TEXT_INPUT
}

export default function (state=defaultState, action) {

    switch (action.type) {

        case "SET_WORLD_STATE":
            return Object.assign({}, state, {
                worldView: action.state
            })

        case "SET_SEARCH_STATE":
            return Object.assign({}, state, {
                searchType: action.state
            })

        case "ADD_TEXT":
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW"
            })
        
        case "SEARCH_DONE":
            return Object.assign({}, state, {
                worldView: "WORLD_SELECT"
            })
        
        case "SEARCH_ERROR":
            return Object.assign({}, state, {
                worldView: "WORLD_ERROR",
            })

        case "MIC_RESET":
            console.log("MICROPHONE RESET on world state");
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW"
            })
        
        case "SPEECH_START":
            return Object.assign({}, state, {
                worldView: "WORLD_INPUT"
            })
        
        case "SEARCH_ERR":
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW"
            })
        
        case "HUD_SPACE_SELECT":
            return Object.assign({}, state, {
                worldView: "WORLD_HUD",
            })
        
        case "HUD_SELECT":
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW",
            })
        
        case "HUD_DISABLE":
            return Object.assign({}, state, {
                worldView: "WORLD_VIEW",
            })

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/global-state.js